<template>
  <div class="details">
    <ul>
      <li>
        <p>订单编号</p>
        <div>{{ info.orderNo }}</div>
      </li>
      <li>
        <p>商品主图</p>
        <div><img :src="info.goodsCover" alt="" /></div>
      </li>
      <li>
        <p>商品标题</p>
        <div>{{ info.goodsName }}</div>
      </li>
      <li>
        <p>规格信息</p>
        <div>{{ info.goodsSkuName }}</div>
      </li>
      <li>
        <p>购买人</p>
        <div>{{ info.userNickname }}</div>
      </li>
      <li>
        <p>购买数量</p>
        <div>{{ info.count }}</div>
      </li>
      <li>
        <p>单价</p>
        <div>￥{{ info.money }}</div>
      </li>
      <li>
        <p>是否包邮</p>
        <div>{{ info.postageType === 0 ? "是" : "否" }}</div>
      </li>
      <li v-if="info.postageType !== 0">
        <p>邮费</p>
        <div>￥{{ info.postage }}</div>
      </li>
      <li>
        <p>实付金额</p>
        <div>{{ info.orderMoney }}</div>
      </li>
      <li>
        <p>订单状态</p>
        <div>{{ info.orderStatus_dictText }}</div>
      </li>
      <li>
        <p>收货人姓名</p>
        <div>{{ info.name }}</div>
      </li>
      <li>
        <p>电话</p>
        <div>{{ info.phone }}</div>
      </li>
      <li>
        <p>地址</p>
        <div>{{ info.address }}</div>
      </li>
      <li>
        <p>下单时间</p>
        <div>{{ info.createdTime }}</div>
      </li>
      <li v-if="info.payTime">
        <p>付款时间</p>
        <div>{{ info.payTime }}</div>
      </li>
      <li v-if="info.deliveryTime">
        <p>发货时间</p>
        <div>{{ info.deliveryTime }}</div>
      </li>
    </ul>
    <div class="btnbox">
      <el-button
        class="enter-btn save-btn"
        v-if="info.orderStatus === 2 || info.orderStatus === 3"
        @click="checkLog()"
        >查看物流</el-button
      >
      <el-button class="cancel-btn calloff-btn" @click="goBack">返回</el-button>
    </div>
    <!-- 查看物流 -->
    <el-dialog
      :visible.sync="logisticsVisible"
      title="查看物流"
      width="40%"
      :before-close="handlelogisticsClose"
      destroy-on-close
      :show-close="false"
    >
      <div slot="title" class="title">
        <p>查看物流</p>
        <span @click="handlelogisticsClose"><i class="el-icon-close"></i></span>
      </div>
      <div class="log-box">
        <div class="log-name">
          <p><img :src="logInfo.logo" alt="" /></p>
          <h4>
            {{ logInfo.name }}{{ logInfo.orderNo }}
            <span @click="copyCode">复制</span>
          </h4>
        </div>
        <div class="log-steps">
          <el-steps
            class="custom-steps"
            direction="vertical"
            process-status="finish"
            :active="0"
          >
            <el-step
              v-for="(item, index) in steps"
              :key="index"
              :title="item.text"
            >
              <div slot="icon" class="icon">
                <p v-if="!index" class="active"></p>
                <p v-else></p>
              </div>
              <div slot="description">
                <p class="row-time">{{ item.desc }}</p>
              </div>
            </el-step>
          </el-steps>
        </div>
        <div class="log-basic">
          <span>[收货人信息] </span> {{ info.name }}, {{ info.phone }},
          {{ info.address }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getOrderDetails, checkExpress } from "@/api/shop";
export default {
  data() {
    return {
      info: {},
      id: this.$route.query.id,
      // 查看物流
      logisticsVisible: false,
      steps: [],
      logInfo: {},
    };
  },
  async created() {
    const res = await getOrderDetails({ id: this.id });
    this.info = res.result;
  },
  mounted() {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 查看物流
    async checkLog() {
      const item = this.info;
      const res = await checkExpress(item.expressNo, item.expressCode);
      let result = JSON.parse(res.result);
      let steps = [];
      if (result.code === "OK") {
        steps = result.list.map((el) => {
          return {
            text: el.content,
            desc: el.time,
          };
        });
      } else {
        steps = [
          {
            text: result.msg,
            desc: result.time,
          },
        ];
      }
      result.orderNo = result.no.split(":")[0];
      this.logInfo = result;
      this.steps = steps;
      this.logisticsVisible = true;
    },
    handlelogisticsClose() {
      this.logisticsVisible = false;
    },
    async copyCode() {
      const textToCopy = this.logInfo.orderNo;
      await navigator.clipboard.writeText(textToCopy);
      // console.log("复制成功");
      this.$message.success("复制成功");
    },
  },
};
</script>
<style lang="scss" scoped>
.details {
  ul {
    li {
      display: flex;
      // align-items: center;
      margin-bottom: 24px;
      > p {
        min-width: 100px;
        font-weight: 400;
        font-size: 14px;
        color: #262626;
        line-height: 20px;
      }
      > div {
        font-weight: 400;
        font-size: 14px;
        color: #262626;
        line-height: 20px;
        img {
          width: 104px;
          height: 104px;
        }
      }
    }
  }
  .btnbox {
    margin-left: 100px;
  }
  ::v-deep .log-box {
    .log-name {
      display: flex;
      align-items: center;
      p {
        width: 38px;
        height: 38px;
        margin-right: 10px;
        border-radius: 100%;
        img {
          width: 100%;
          height: 100%;
          border-radius: 100%;
        }
      }
      h4 {
        font-weight: 600;
        font-size: 15px;
        color: #262626;
        line-height: 21px;
        span {
          font-weight: 400;
          font-size: 15px;
          color: #ff5d2f;
          line-height: 21px;
          margin-left: 12px;
          cursor: pointer;
        }
      }
    }
    .log-steps {
      margin: 20px 0 4px;
      // max-height: 300px;
      // overflow-y: scroll;
      .el-step__icon {
        width: 9px;
        height: 9px;
        border: none;
      }
      .el-step__line {
        left: 4px;
        width: 1px;
        background: #c8c9ca;
        top: 9px;
        bottom: 0;
      }
      .icon {
        p {
          width: 9px;
          height: 9px;
          background: #d8d8d8;
          border-radius: 12px;
        }
        .active {
          background: #ff5d2f;
        }
      }
      .row-time {
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        line-height: 20px;
        margin-bottom: 14px;
      }
      .el-step__title {
        padding-bottom: 2px;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        line-height: 20px;
      }
      .is-finish {
        color: #ff5d2f;
        .row-time {
          color: #161616;
        }
      }
    }
    .log-basic {
      // display: flex;
      padding: 10px 18px 11px 5px;
      background: #f5f6f6;
      border-radius: 6px;
      font-weight: 400;
      font-size: 14px;
      color: #262626;
      line-height: 20px;
      span {
        font-weight: 600;
      }
    }
  }
}
</style>
